import SearchHead from "components/searchHead";
import { useTranslation } from "react-i18next";
import Base from "./base";
import "./home.scss";

export default function HomePage() {
  const { t } = useTranslation();
  return (
    <>
      <SearchHead
        title={t("sub_ttl_1")}
        formId={""}
        isButs={false}
        onClick={() => {}}
      />
      <div className="home">
        <Base />
      </div>
    </>
  );
}
